import styled from "styled-components";

import heroBg from "../../../assets/images/pattern-white.jpg";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Hero = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  background-color: #9457a3;
`;

export const HeroImageContainer = styled.div`
  width: 100%;
  height: 264px;
  background-image: url(${heroBg});
  background-repeat: no-repeat;
  background-position-x: left;
  background-position-y: top;
  mix-blend-mode: multiply;

  @media (width < 4000px) {
    background-size: 2260px auto;
  }

  @media (width >= 4000px) {
    background-size: 100% auto;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  padding: 24px;
`;

export const Title = styled.h1`
  font-size: 65px;
  font-weight: 500;
  line-height: 68px;
  text-align: center;
`;
